import { render } from "./OutsideAssignment.vue?vue&type=template&id=839b6a06"
import script from "./OutsideAssignment.vue?vue&type=script&lang=js"
export * from "./OutsideAssignment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__